import React, { useCallback } from 'react'
import { Button } from 'antd'
import PropTypes from 'prop-types'

import { PERMISSIONS } from '../../../common/constants'

import { useUserHasPermissions } from '../../../account/hooks'
import { useDeleteFakeBrandMutation } from '../../hooks'

const BrandCurationTaskDeleteButton = ({ brandId }) => {
  const [deleteFakeBrand] = useDeleteFakeBrandMutation()

  const hasPermissionToDelete = useUserHasPermissions(
    PERMISSIONS.BRAND_CURATION_TASK.DELETE,
  )

  const handleDelete = useCallback(() => {
    deleteFakeBrand(brandId)
  }, [deleteFakeBrand, brandId])

  return (
    <Button disabled={!hasPermissionToDelete} onClick={handleDelete}>
      Delete fake brand
    </Button>
  )
}

BrandCurationTaskDeleteButton.propTypes = {
  brandId: PropTypes.string.isRequired,
}

export default BrandCurationTaskDeleteButton
